import { connect } from 'react-redux';
import withRankingSubscription from '../../../hoc/withRankingSubscription';
import OverviewTable from '../../../components/front/overview/OverviewTable';
import {
    connectionError,
    fetchRanks,
    newRanks,
    updateRank,
} from '../../../actions/overview';

function mapStateToProps({ overview }) {
    return { ...overview };
}

const mapDispatchToProps = {
    create: newRanks,
    connectionError,
    fetch: fetchRanks,
    update: updateRank,
};

export default connect(mapStateToProps, mapDispatchToProps)(
    withRankingSubscription(OverviewTable)
);



/** WEBPACK FOOTER **
 ** /src/shared/containers/front/overview/OverviewTable.js
 **/